import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js'
import Section from './Section.js'
import RequiredDocForm from './RequiredDocForm';
import CustomSpinner from './CustomSpinner';

require(`../assets/${process.env.PAGE}/css/components/upload-documents.css`);


class UploadDocuments extends Component {

    constructor(props) {
        super(props);
        this.state = {
            requiredDocuments: {
                payment_invoice: false,
                bank_transactions_details: false,
            }
        };
        this.updateDocumentStatus = this.updateDocumentStatus.bind(this);
    }

    updateDocumentStatus(documentType){
        let newState = {...this.state};
        newState.requiredDocuments[documentType] = true;
        this.setState({...newState});
    }


    render() {
        const { handleSubmit, submitting, error } = this.props;
        const { requiredDocuments: { payment_invoice, bank_transactions_details } } = this.state;
        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center" >
                        <div className="header-img" >
                            <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo_blanco_montemar.png`)} />
                        </div>
                        <div className="header-message">
                            <FormattedHTMLMessage id="app.step_upload_documents" description="Upload Document Information"/>
                        </div>
                    </div>
                    <div className="pd-content-right short-content col-sm-12 col-md-7 col-lg-7">
                        <form  className="pvc-form" onSubmit={handleSubmit(this.props.getStep)}>
                        {this.props.isLoading && <CustomSpinner message='Estamos buscando tu auto ideal' /> }
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="upload-title">
                                        Adjuntá los siguiente documentos:
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <RequiredDocForm
                                        label={'Último Bono de Sueldo'}
                                        documentType={'payment_invoice'}
                                        maxSize={10000000}
                                        fileTypes={['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}
                                        onUpdateStatus={this.updateDocumentStatus}/>
                                    <RequiredDocForm
                                        label={'Últimos Movimientos Cuenta Sueldo'}
                                        documentType={'bank_transactions_details'}
                                        maxSize={10000000}
                                        fileTypes={['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}
                                        onUpdateStatus={this.updateDocumentStatus}/>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={!(payment_invoice && bank_transactions_details)}>Seguir</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Section>
        );
    }
}

UploadDocuments.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

UploadDocuments = TopScrolleable(UploadDocuments);

UploadDocuments = reduxForm({
    form: 'UploadDocuments', // a unique name for this form
})(UploadDocuments);

UploadDocuments = withAuthControl(UploadDocuments);

export default UploadDocuments;


/** WEBPACK FOOTER **
 ** ./src/components/UploadDocuments.js
 **/